import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { TransportOrderStatus } from '../../../../domain/transportOrder';

export const countActiveOrders = (orderCount: Record<TransportOrderStatus, number>): number => {
    const validStatuses: TransportOrderStatus[] = ['CREATED', 'LOADED', 'UNLOADED', 'DONE'];
    return validStatuses.reduce((sum, status) => sum + (orderCount[status] || 0), 0);
};

export const countAllOrders = (orderCount: Record<TransportOrderStatus, number>): number => {
    return Object.values(orderCount).reduce((sum, count) => sum + count, 0);
};

// Helper function to create tooltip content showing counts for each status
const createOrderCountTooltip = (orderCount: Record<TransportOrderStatus, number>) => {
    const statusLabels: Record<TransportOrderStatus, string> = {
        'DRAFT': 'Szkic',
        'CREATED': 'Utworzone',
        'LOADED': 'Załadowane',
        'UNLOADED': 'Rozładowane',
        'DONE': 'Zakończone',
        'STORNO': 'Storno'
    };

    return (
        <Tooltip id="order-count-tooltip">
            <div className="text-start">
                {Object.entries(orderCount).map(([status, count]) => (
                    <div key={status}>
                        {statusLabels[status as TransportOrderStatus]}: {count}
                    </div>
                ))}
            </div>
        </Tooltip>
    );
};

export const formatOrderCount = (orderCount: Record<TransportOrderStatus, number>): React.ReactNode => {
    const activeOrdersCount = countActiveOrders(orderCount);
    const stornoCount = orderCount['STORNO'] || 0;
    const draftCount = orderCount['DRAFT'] || 0;

    const content = (
        <>
            {activeOrdersCount.toString()}
            {(stornoCount > 0 || draftCount > 0) && (
                <span className="text-secondary">
                    {` (+${[
                        stornoCount > 0 ? `${stornoCount} storno` : null,
                        draftCount > 0 ? `${draftCount} draft` : null
                    ].filter(Boolean).join(', + ')})`}
                </span>
            )}
        </>
    );

    return (
        <OverlayTrigger
            placement="top"
            overlay={createOrderCountTooltip(orderCount)}
        >
            <span style={{ cursor: 'help' }}>{content}</span>
        </OverlayTrigger>
    );
};